<div [ngClass]="checkClass || 'status__label--active'" class="status__label">
  <div class="status__label--grow">{{ checkText }}</div>
</div>
